import * as React from 'react';
import { useSelector } from 'react-redux';
import {
  orgPayPeriodSelector,
  orgSubscriptionEndSelector,
  orgCheckoutProjectedUpcomingAmountDueSelector,
} from '../../../redux/app/selectors/organization';

interface CheckoutSubscriptionSummaryProps {
  payPeriod: string;
}

export const CheckoutSubscriptionSummary = () => {
  const upcomingInvoiceAmountDue = useSelector(orgCheckoutProjectedUpcomingAmountDueSelector);
  const payPeriod = useSelector(orgPayPeriodSelector);
  const subscriptionEnd = useSelector(orgSubscriptionEndSelector);

  return (
    <div className="subscription-notice">
      <div className="flex">
        <p className="info-icon">ⓘ</p>
        <div className="next-invoice">
          <p className="bold-800 gray mb-5">Next Invoice</p>
          <p className="bold-800 gray">{`${upcomingInvoiceAmountDue} on ${subscriptionEnd}`}</p>
        </div>
        <p>
          {`Unless you make any changes to your plan you will be billed
          automatically every ${payPeriod === 'monthly' ? 'monthy' : 'year'}. You can make changes and cancel your plan at any time.`}
        </p>
      </div>
    </div>
  );
};
